module.exports = __webpack_public_path__ + "img/photo_upload.e3a62c21.png";